import { Routes, Route } from "react-router-dom";
import AdminLayout from "../layout/adminLayout";
import DashboardPage from "../pages/admin/DashboardPage";
import ProductManagement from "../pages/admin/ProductManagement";
import TransactionPage from "../pages/admin/TransactionPage";
import GitHubCodePage from "../pages/admin/GitHubCodePage";
import NotFoundPage from "../pages/notFound/NotFoundPage";

import ReviewManagement from "../pages/admin/pages/ReviewManagement";
import VideoManagement from "../pages/admin/pages/VideoManagement";
import OrderManagement from "../pages/admin/pages/OrderManagement";
import OrderDetailPage from "../pages/admin/pages/OrderDetailPage";
import UserManagement from "../pages/admin/pages/UserManagement";
import Settings from "../pages/admin/pages/Settings";
import DeliverableManagement from "../pages/admin/pages/DeliverableManagement";
import DeliveryIssues from "../pages/admin/pages/DeliveryIssues";
import EnquiryManagement from "../pages/admin/pages/EnquiryManagement";

const AdminRoutes = () => {
  return (
    <AdminLayout>
      <Routes>
        <Route index element={<DashboardPage />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="products" element={<ProductManagement />} />
        <Route path="transactions" element={<TransactionPage />} />
        <Route path="github-codes" element={<GitHubCodePage />} />
        <Route path="deliverables" element={<DeliverableManagement />} />
        <Route path="reviews" element={<ReviewManagement />} />
        <Route path="videos" element={<VideoManagement />} />
        <Route path="orders" element={<OrderManagement />} />
        <Route path="orders/:id" element={<OrderDetailPage />} />
        <Route path="delivery-issues" element={<DeliveryIssues />} />
        <Route path="enquiries" element={<EnquiryManagement />} />
        <Route path="users" element={<UserManagement />} />
        <Route path="settings" element={<Settings />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </AdminLayout>
  );
};

export default AdminRoutes;
